const hRecaptchaUtil = {
    initRecaptchaScript: () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = `https://www.google.com/recaptcha/api.js?render=${environmentsConfig.get('GoogleRecaptchaSiteKey')}`;
            script.onload = () => {
                resolve();
            };
            script.onerror = function () {
                console.error("Failed to load the reCAPTCHA script");
            };
            document.getElementsByTagName('head')[0].appendChild(script);
        });
    },
    execute: (action = `login`) => {
        return new Promise((resolve, reject) => {
            grecaptcha.ready(() => {
                grecaptcha.execute(environmentsConfig.get('GoogleRecaptchaSiteKey'), {action: action})
                    .then((token) => {
                        resolve(token);
                    })
                    .catch((err) => {
                        console.error(err);
                        reject(err);
                    });
            });
        });
    }
};

window.hRecaptchaUtil = hRecaptchaUtil;
